
export default {
  props: {
    videoDetailResponse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPlay: false,
      isVideoLoading: false,
      videoStatus: "", //video状态  ["playing", "paused", "ended"]
      origin: "",
      player: null
    };
  },
  mounted() {
    this.origin = window.location.origin;
    window.onYouTubeIframeAPIReady = () => {
      console.log("YouTube iframe API is ready");
    };
    window.addEventListener("message", (event) => {
      if (event.origin === "https://www.youtube.com") {
        // console.log("Received message from YouTube", JSON.parse(event.data));
        if (JSON.parse(event.data).event === "onStateChange") {
          switch (JSON.parse(event.data).info) {
            case 1:
              this.videoStatus = "playing";
              break;
            case 2:
              this.videoStatus = "paused";
              break;
            case 0:
              this.videoStatus = "ended";
              break;
          }
        }
        return;
      }
    });
  },
  methods: {
    handlePlay() {
      this.isVideoLoading = true;
      window.dataLayer.push({
        event: "Play_Incentive_AD"
      });
      try {
        // 设置加载最大时长
        setTimeout(() => {
          // 激励未展示成功
          if (this.isVideoLoading) {
            this.isVideoLoading = false;
            this.showPlayerIframe();
          }
        }, 5000);

        window.dataLayer.push({
          event: "Q_IR"
        });
        /**
         * 激励广告
         * **/
        // eslint-disable-next-line no-undef
        (adsbygoogle = window.adsbygoogle || []).push({
          params: {
            google_ad_loaded_callback: this.loadRewardedAd,
            google_ad_slot: 6875183545,
            google_ad_format: "rewarded"
          }
        });
      } catch (e) {
        this.isVideoLoading = false;
        this.showPlayerIframe();
      }
    },
    loadRewardedAd(rewardedAd) {
      if (rewardedAd == null) {
        console.log("No rewarded ad loaded");
        // 加载失败
        this.isVideoLoading = false;
        this.showPlayerIframe();
        return;
      }
      rewardedAd.show((result) => {
        const closeStatus = result.status;
        if (closeStatus === "viewed") {
          // 用户观看了激励广告
          this.showPlayerIframe();
          window.dataLayer.push({
            event: "V_IR"
          });
        }
        // 用户关闭广告
        else if (closeStatus === "dismissed") {
          window.dataLayer.push({
            event: "F_IR"
          });
        }
      });
      this.isVideoLoading = false;
      // 展示激励广告
      window.dataLayer.push({
        event: "C_IR"
      });
    },
    showPlayerIframe() {
      this.isPlay = true;

      this.$nextTick(() => {
        const iframe = this.$refs.playerIframe;
        if (iframe) {
          iframe.onload = this.onIframeLoaded;
          iframe.onerror = this.onIframeError;
        }
      });
    },
    randomVideo() {
      if (this.videoStatus === "playing") {
        return;
      }
      const links = document.querySelectorAll('a[href*="/video"]');
      const randomIndex = Math.floor(Math.random() * links.length);
      const randomLink = links[randomIndex];
      randomLink.click();
    },
    onIframeLoaded() {
      this.isVideoLoading = false;

      this.player = new window.YT.Player("player", {
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange
        }
      });
    },
    onIframeError() {
      this.isVideoLoading = false;
    },
    onPlayerReady(event) {
      console.log("Player is ready");
    },
    onPlayerStateChange(event) {
      console.log("Player state changed", event);
    }
  }
};
